import {
    endOfQuarter,
    startOfQuarter,
    startOfDay,
    addDays,
    startOfWeek,
    addWeeks,
    endOfWeek,
    startOfMonth,
    addMonths,
    endOfMonth,
    startOfYear,
    addYears,
    endOfYear,
    addQuarters, format
} from "date-fns"
import Vue from "vue";

export const translatePeriods = (periodString, forceFirstDayOfWeek, info) => {
    let weekStartsOn = Vue.formatting.first_week_day % 7

    if (forceFirstDayOfWeek) {
        // notice :: if issues with USA flextime forced start on Monday, remove next line
        weekStartsOn = forceFirstDayOfWeek
        // console.warn('weekStartsOn :: ' + info, weekStartsOn)
    } else {
        // console.error('ERROR weekStartsOn :: ' + info, weekStartsOn)
    }

    let offset = periodString.split("_");
    if (offset[0] === "d") {
        return format(startOfDay(addDays(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    } else if (offset[0] === "sow") {
        return format(startOfWeek(addWeeks(new Date(), Number(offset[1])), {weekStartsOn: weekStartsOn}), "yyyy-MM-dd");
    } else if (offset[0] === "eow") {
        return format(endOfWeek(addWeeks(new Date(), Number(offset[1])), {weekStartsOn: weekStartsOn}), "yyyy-MM-dd");
    } else if (offset[0] === "som") {
        return format(startOfMonth(addMonths(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    } else if (offset[0] === "eom") {
        return format(endOfMonth(addMonths(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    } else if (offset[0] === "soy") {
        return format(startOfYear(addYears(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    } else if (offset[0] === "eoy") {
        return format(endOfYear(addYears(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    } else if (offset[0] === "soq") {
        return format(startOfQuarter(addQuarters(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    } else if (offset[0] === "eoq") {
        return format(endOfQuarter(addQuarters(new Date(), Number(offset[1]))), "yyyy-MM-dd");
    }
}

export default {
    translatePeriods
}